/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Soft_Vast_Lynx_FawnInputs */

const en_soft_vast_lynx_fawn = /** @type {(inputs: Soft_Vast_Lynx_FawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generally Shared Segments (${i?.count})`)
};

const de_soft_vast_lynx_fawn = /** @type {(inputs: Soft_Vast_Lynx_FawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allgemein freigegebene Segmente (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Generally Shared Segments ({count})" |
*
* @param {Soft_Vast_Lynx_FawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_vast_lynx_fawn = /** @type {((inputs: Soft_Vast_Lynx_FawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Vast_Lynx_FawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_vast_lynx_fawn(inputs)
	return de_soft_vast_lynx_fawn(inputs)
});